import { forwardRef, type ReactNode } from "react";
import { FiCheck } from "react-icons/fi";

export type FlowStepStatus = "locked" | "active" | "done";

interface Props {
    step: number;
    label: string;
    status: FlowStepStatus;
    isLast?: boolean;
    className?: string;
    children: ReactNode;
}

const ImageFlowStep = forwardRef<HTMLElement, Props>(function ImageFlowStep(
    { step, label, status, isLast = false, className = "", children },
    ref
) {
    const locked = status === "locked";

    return (
        <section ref={ref} className={`scroll-mt-20 ${className}`}>
            <div className="flex items-stretch gap-3">
                <div className="flex w-7 shrink-0 flex-col items-center">
                    <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold ${
                            status === "active"
                                ? "bg-[#1DA8C6] text-[#08151A]"
                                : status === "done"
                                  ? "border border-[rgba(29,168,198,0.45)] bg-[rgba(29,168,198,0.16)] text-[#1DA8C6]"
                                  : "border border-white/10 text-[#6B6C72]"
                        }`}
                    >
                        {status === "done" ? (
                            <FiCheck className="h-4 w-4" />
                        ) : (
                            step
                        )}
                    </span>
                    {!isLast && (
                        <span className="my-1.5 min-h-4 w-px flex-1 bg-white/10" />
                    )}
                </div>
                <div className={`min-w-0 flex-1 ${isLast ? "" : "pb-5"}`}>
                    <div
                        className={`mb-3 inline-flex items-center rounded-[10px] px-3 py-2 ${
                            status === "active" ? "bg-[#1a1b1e]" : ""
                        }`}
                    >
                        <span
                            className={`text-lg ${
                                status === "active"
                                    ? "font-semibold text-[#1DA8C6]"
                                    : status === "done"
                                      ? "font-medium text-[#F1F0EA]"
                                      : "font-medium text-[#6B6C72]"
                            }`}
                        >
                            {label}
                        </span>
                    </div>
                    <div className={locked ? "pointer-events-none select-none" : ""}>
                        {children}
                    </div>
                </div>
            </div>
        </section>
    );
});

export default ImageFlowStep;
